//TODO : KB 상품 여부 확인
export const isKbProduct = value => {
  //상품 : 건강파트너 종신보험(해지환급금 미지급형)
  if (value === '421162N') {
    return true;
  } else {
    return false;
  }
};

export const commaNumValue = value => {
  if (!isNull(value)) {
    if (value.toString().indexOf('.') > -1) {
      return value;
    } else {
      let numValue = value.toString().replace(/[^0-9]/g, '');
      numValue = numValue.replaceAll(',', '');
      const commaValue = numValue
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return commaValue;
    }
  } else {
    return '';
  }
};

export const getNumValue = value => {
  let numValue = value.toString().replace(/[^0-9]/g, '');
  numValue = numValue.replaceAll(',', '');

  return numValue;
};

export const getCommas = value => {
  let numValue = value.toString().replace(/[^0-9]/g, '');
  numValue = numValue.replaceAll(',', '');

  return numValue;
};

export const isNull = value => {
  if (value === undefined || value === '' || value == null) {
    return true;
  } else {
    return false;
  }
};

export const findRow = (map, column, value) => {
  const idx = map.findIndex(rider => rider.column === value);
  return idx;
};

/*
 * 오늘날짜를 "20180921" 형태로 반환 한다.
 */

export const kbGetToday = () => {
  let date = new Date();
  let val_fullYear = date.getFullYear(); //년도
  let val_month = zeroPad(date.getMonth() + 1, 2); //월
  let val_date = zeroPad(date.getDate(), 2); //날짜
  return val_fullYear + val_month + val_date;
};

/*
 * 주로 "월", "날짜 "에 사용하며
 * zeroPad ("1", 3 )  => "001" 반환
 */
export const zeroPad = (number, length) => {
  let str_Number = String(number);

  let cnt_zero = parseInt(length) - str_Number.length;

  let str_zero = '';
  for (let i = 0; i < cnt_zero; i++) {
    str_zero += '0';
  }
  return str_zero + String(number);
};

/**
 * 만나이를 계산합니다 보험 가입이 만 19세부터 가입이 가능해서 보험나이가 19세이더라도 가입이 불가능 해서 에러가 발생하는 부분이 있어
 * 해당 로직을 추가해 보험금 확인을 불가하게 만들려고 추가합니다 dateString : 8902021(생년월일+성별)
 */

export const getRealAge = dateString => {
  if (isJuminno(dateString.substring(0, 6), 1) == false) {
    return false;
  }

  // 기준일자
  var sdDate = new Date(setFmDate(kbGetToday(), '/'));

  if (
    dateString.length == 13 ||
    dateString.length == 7 ||
    dateString.length == 6
  ) {
    dateString = seBrithYear(dateString);
  }

  var jmDate = new Date(setFmDate(dateString, '/'));

  var age = sdDate.getFullYear() - jmDate.getFullYear();

  if (sdDate.getMonth() < jmDate.getMonth()) age--;
  if (
    sdDate.getMonth() == jmDate.getMonth() &&
    sdDate.getDate() < jmDate.getDate()
  )
    age--;

  return age;
};

/**
 * 주민번호 유효성 체크 (가벼운 유효성) 각 자리수에 들어갈 수 있는 숫자만 체크하여 결과를 반환합니다.
 *
 * @param juminno
 */
export const isJuminno = (juminno, position) => {
  // 주민번호 유효성 체크
  var regExp = new RegExp();
  if (undefined == position)
    regExp =
      /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))[1-8][0-9]{6}$/;
  else if ('-' == position)
    regExp =
      /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-8][0-9]{6}$/;
  else if ('1' == position)
    regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
  else if ('2' == position) regExp = /^[1-8][0-9]{6}$/;

  if (!regExp.test(juminno)) {
    return false;
  }
  return true;
};
/**
 * 설정한 모든 date 포멧을 뺀다.
 */
const allUnFmDate = orgDate => {
  var rtnDate = orgDate.replaceAll('-', '');
  rtnDate = rtnDate.replaceAll('.', '');
  rtnDate = rtnDate.replaceAll('/', '');

  return rtnDate;
};

/**
 * TODO 송지웅 setFmDate 함수 변경함. 문제 안생길시 변경한 함수로 진행
 * 오늘 날짜 to string
 * @param {string} dateFormat 날짜 포맷
 * @returns
 */
// export const setFmDate = (dateFormat = 'yyyy/MM/dd') => {
//   return format(new Date(), dateFormat);
// };
/**
 * 입력된 문자열이 yyyyMM의 날짜형식인지 확인한다.
 *
 * @param -
 *            String - "YYYYMM" 형식의 날짜 스트링
 * @returns - Boolean - 날짜형식일경우 true, 날짜가 아닐경우 false
 */
const isDate6 = curdate => {
  var i, year, month, day;

  if (chkReturn(curdate) == false || curdate.length < 6) {
    return false;
  }

  for (i = 0; i < curdate.length; i++) {
    if (curdate.charAt(i) < '0' || curdate.charAt(i) > '9') {
      return false;
    }
  }

  if (LTrim(curdate.substring(0, 4), '0').length == 0) {
    return false;
  } else {
    year = parseInt(LTrim(curdate.substring(0, 4), '0'), 10);
  }

  if (LTrim(curdate.substring(4, 6), '0').length == 0) {
    return false;
  } else {
    month = parseInt(LTrim(curdate.substring(4, 6), '0'), 10);
  }

  if (month > 12) {
    return false;
  }

  return true;
};
/**
 * YYYYMMDD 형식 문자열을 YYYY-MM-DD 형식으로 변환 strToken 미입력시는 "-"으로 기본 파싱하며 값이 있을경우
 * 해당값으로 파싱
 *
 * @param strDate -
 *            String - YYYYMMDD 형식으로 문자열
 * @param strToken -
 *            String - "."등 형식으로 변환 원할경우 사용, 미입력시 "-"로 파싱 "년월일"일 경우 "YYYY년 MM월
 *            DD일"로 리턴한다.
 * @returns String - 변경된 문자열
 */
export const setFmDate = (strDate, strToken) => {
  if (chkReturn(strDate, 's') == '') {
    return '';
  }

  var date = allUnFmDate(strDate);

  if (isDate6(date) == false) {
    message.alert('CO.0014');
    return strDate;
  }

  if (date.length == 8 && isDate(date) == false) {
    message.alert('CO.0014');
    return strDate;
  }

  var strSetToken = '/';

  if (chkReturn(strToken) == true) {
    strSetToken = strToken;
  }

  var strYear = date.substring(0, 4);
  var strMonth = date.substring(4, 6);
  var strDay = '';

  if (date.length == 8) {
    strDay = date.substring(6, 8);
    if (strSetToken == '년월일') {
      return strYear + '년 ' + strMonth + '월 ' + strDay + '일';
    } else {
      return strYear + strSetToken + strMonth + strSetToken + strDay;
    }
  }

  return strYear + strSetToken + strMonth;
};

const seBrithYear = dateString => {
  if (
    dateString.length == 13 ||
    dateString.length == 7 ||
    dateString.length == 6
  ) {
    var sex = dateString.substr(6, 1);

    //현재년도
    var nowDate = kbGetToday();
    var nowY2 = nowDate.substr(2, 2);
    var nowY1 = nowDate.substr(0, 2);
    var Y1 = '';
    var Y2 = dateString.substr(0, 2);

    if (
      Number(nowY2) < Number(Y2) &&
      (sex == '1' || sex == '2' || sex == '5' || sex == '6')
    ) {
      Y1 = Number(nowY1) - 1 + '';
    } else if (Number(nowY2) >= Number(Y2)) {
      Y1 = nowY1;
    } else if (sex == '3' || sex == '4' || sex == '7' || sex == '8') {
      Y1 = nowY1;
    }

    dateString = Y1 + dateString.substring(0, 6);

    return dateString;
  } else {
    message.alert('VL.0028');
  }
};

/**
 * M2 서버 관련 도메인 및 중간저장
 * */
export const getM2Host = (accessServer, server) => {
  let m2Host = '';
  let m2Protocol = '';

  if (location.protocol.indexOf('file') > -1) {
    m2Protocol = 'https:';
  } else {
    m2Protocol = location.protocol;
  }

  /* 분기점
   *  pre		(M2PRE : 전처리 서버)
   *  inf 		(M2INF : 제출 서버)
   *  infSave	(M2INF : 중간저장 서버)
   *  rd  		(M2RD  : 리포트 디자이너)
   */
  if (accessServer == 'DEV') {
    //개발서버
    if (server == 'pre') {
      m2Host = m2Protocol + '//tm2pre.kbli.co.kr/service';
    } else if (server == 'inf') {
      m2Host = m2Protocol + '//tm2inf.kbli.co.kr/service';
    } else if (server == 'infSave') {
      m2Host = m2Protocol + '//tm2inf.kbli.co.kr';
    } else {
      m2Host += m2Protocol + '//tm2rd.kbli.co.kr/service';
    }
  } else if (accessServer == 'UAT') {
    //UAT
    if (server == 'pre') {
      m2Host = m2Protocol + '//um2pre.kbli.co.kr/service';
    } else if (server == 'inf') {
      m2Host = m2Protocol + '//um2inf.kbli.co.kr/service';
    } else if (server == 'infSave') {
      m2Host = m2Protocol + '//um2inf.kbli.co.kr';
    } else {
      m2Host += m2Protocol + '//um2rd.kbli.co.kr/service';
    }
  } else if (accessServer == 'PRODUCT') {
    //운영 - 추후 변경
    if (server == 'pre') {
      m2Host = m2Protocol + '//m2pre.kbli.co.kr/service';
    } else if (server == 'inf') {
      m2Host = m2Protocol + '//m2inf.kbli.co.kr/service';
    } else if (server == 'infSave') {
      m2Host = m2Protocol + '//m2inf.kbli.co.kr';
    } else {
      m2Host = m2Protocol + '//m2rd.kbli.co.kr/service';
    }
  } else {
    //로컬
    if (server == 'pre') {
      m2Host = m2Protocol + '//localhost:8180/m2pre/service';
    } else if (server == 'inf') {
      m2Host = m2Protocol + '//localhost:8180/m2inf/service';
    } else if (server == 'infSave') {
      m2Host = m2Protocol + '//localhost:8180/m2inf';
    } else {
      m2Host = m2Protocol + '//localhost:8180/m2rd/service';
    }
  }
  return m2Host;
};

/**
 * 	Object의 Null 여부에 따른 값 변환
 * @param obj
 * @param str	변환 값
 * @returns
 */

export const stringNvl = (obj, str) => {
  if (
    typeof obj == 'undefined' ||
    obj == null ||
    obj === '' ||
    obj == 'null' ||
    obj == 'undefined'
  ) {
    if (
      typeof str == 'undefined' ||
      str == null ||
      str === '' ||
      str == 'null' ||
      str == 'undefined'
    ) {
      return '';
    } else {
      return str;
    }
  } else {
    return obj;
  }
};

/**
 * 입력할 날짜(YYYYMMDD)를 기준으로 주민등록번호로 보험나이를 계산
 * sCntrctDt : 현재날짜
 * sIdNo 주민번호
 * */
export const getLinaAge = (sCntrctDt, sIdNo) => {
  var sBornDt = '';

  if (sIdNo == undefined) {
    return;
  }

  if (
    sIdNo.substring(6, 7) == '3' ||
    sIdNo.substring(6, 7) == '4' ||
    sIdNo.substring(6, 7) == '7' ||
    sIdNo.substring(6, 7) == '8'
  ) {
    sBornDt = '20' + sIdNo.substring(0, 6);
  } else {
    sBornDt = '19' + sIdNo.substring(0, 6);
  }

  var nB_YYYY = parseInt(sBornDt.substring(0, 4)); //생년월일의 년
  var nB_MM = parseInt(sBornDt.substring(4, 6)); //생년월일의 월
  var nB_DD = parseInt(sBornDt.substring(6, 8)); //생년월일의 일
  var nC_YYYY = parseInt(sCntrctDt.substring(0, 4)); //계약일의 년
  var nC_MM = parseInt(sCntrctDt.substring(4, 6)); //계약일의 월
  var nC_DD = parseInt(sCntrctDt.substring(6, 8)); //계약일의 일

  if (nC_DD < nB_DD) {
    nC_MM = nC_MM - 1;
    //nC_DD = nC_DD + aMaxDay[parseInt(nC_MM)-1];
    var day = '';

    if (isDate(sBornDt)) {
      day = addDate(sBornDt, 'm', -1);
    }

    var rtnDate = getEtcDate(day);

    if (rtnDate['lastDate'] != undefined) {
      nC_DD = nC_DD + rtnDate['lastDate'].substring(6, 8); //aMaxDay[parseInt(nC_MM)-1];
    }
  }

  if (nC_MM < nB_MM) {
    nC_YYYY = nC_YYYY - 1;
    nC_MM = nC_MM + 12;
  }

  var nR_YYYY = nC_YYYY - nB_YYYY;
  var nR_MM = nC_MM - nB_MM;
  var nR_DD = nC_DD - (nB_DD + 1);

  if (nR_MM > 5 || (nR_MM == 5 && nR_DD == 30)) {
    return nR_YYYY + 1;
  } else {
    return nR_YYYY;
  }
};

/**
 * 입력된 문자열이 yyyyMMdd의 날짜형식인지 확인한다.
 *
 * @param -
 *            String - "YYYYMMDD" 형식의 날짜 스트링
 * @returns - Boolean - 날짜형식일경우 true, 날짜가 아닐경우 false
 */
export const isDate = curdate => {
  var i, year, month, day;

  if (curdate.length < 8) {
    return false;
  }

  for (i = 0; i < curdate.length; i++) {
    if (curdate.charAt(i) < '0' || curdate.charAt(i) > '9') {
      return false;
    }
  }

  if (LTrim(curdate.substring(0, 4), '0').length == 0) {
    return false;
  } else {
    year = parseInt(LTrim(curdate.substring(0, 4), '0'), 10);
  }

  if (LTrim(curdate.substring(4, 6), '0').length == 0) {
    return false;
  } else {
    month = parseInt(LTrim(curdate.substring(4, 6), '0'), 10);
  }

  if (LTrim(curdate.substring(6, 8), '0').length == 0) {
    return false;
  } else {
    day = parseInt(LTrim(curdate.substring(6, 8), '0'), 10);
  }

  if (year == 0) {
    return false;
  }
  if (month == 0 || month > 12) {
    return false;
  }

  if (day == 0 || day > getLastDay(year, month)) {
    return false;
  }

  return true;
};

// ltrim
export const LTrim = st => {
  return st.replace(/^\s+/, '');
};

/**
 * 해당 년월의 마지막날 구하기
 */
export const getLastDay = (year, month) => {
  var day = new Date(new Date(year, month, 1) - 86400000).getDate();
  if (year == 9999) {
    day = 99;
  }
  if (day.length == 1) {
    day = '0' + day;
  }
  return day;
};

/**
 * yyyyMMdd 타입의 날짜를 받아 년,월,일에 날짜를 더하거나 뺀다. 변수 strReType에 'n'을 세팅하면 int형으로 리턴한다.
 *
 * @param strDate -
 *            String - yyyyMMdd 형태의 날짜 스트링
 * @param strType -
 *            String - 더하거나 뺄 곳, 년: "y", 월: "m", 일: "d"
 * @param nValue -
 *            Intger - 더하건 뺄 값
 * @param strReType -
 *            String - 입력하지 않거나 빈스트링일경우 문자형 리턴, "n"등 입력할경우 int형 리턴
 * @returns 문자열 혹은 number 형 yyyyMMdd 리턴
 */
export const addDate = (strDate, strType, nValue, strReType) => {
  var nYear = parseInt(strDate.substring(0, 4), 10);
  var nMonty = parseInt(strDate.substring(4, 6) - 1, 10);
  var nDate = parseInt(strDate.substring(6, 8), 10);

  if (strType == 'y') {
    nYear = nYear + nValue;
  } else if (strType == 'm') {
    nMonty = nMonty + nValue;
  } else if (strType == 'd') {
    nDate = nDate + nValue;
  }

  var dtInDate = new Date(nYear, nMonty, nDate);
  var strYear = '' + dtInDate.getFullYear();
  var strMonth = '' + (dtInDate.getMonth() + 1);
  var strDay = '' + dtInDate.getDate();

  if (strMonth.length == 1) {
    strMonth = '0' + strMonth;
  }
  if (strDay.length == 1) {
    strDay = '0' + strDay;
  }

  return strYear + strMonth + strDay;
};

/**
 * 기타 날짜를 계산한다.
 */
export const getEtcDate = inputDate => {
  var rtnDate = {};

  // 입력 날짜를 세팅한다.
  rtnDate['inputDate'] = inputDate;

  // 입력 날짜의 1일을 계산한다.
  var inputYearMonth = inputDate.substring(0, 6);
  var firstDate = inputYearMonth + '01';
  rtnDate['firstDate'] = firstDate;

  // 입력 날짜의 말일을 계산한다.
  var lastDate = addDate(addDate(firstDate, 'm', 1), 'd', -1);
  rtnDate['lastDate'] = lastDate;

  return rtnDate;
};

/**
 * 서버 시간 Object를 가져 옵니다
 */
export const getServerTime = () => {
  var dtServerDate = new Date();

  // 일부 청약 오류로 원복 2021.09.13
  // var param = {};
  // $.ajax({
  // 	url		: "/com/getCurrentDateString.do",
  // 	type	: "POST",
  // 	async	: false,
  // 	dataType: "json",
  // 	contentType : "application/json",
  // 	data	: JSON.stringify(param),
  // 	success : function(result) {
  // 		if(result == null) {
  // 			result = {
  // 				_v_server_date : new Date()
  // 			}
  // 		}
  // 		var serverDt = stringNvl(result._v_server_date, new Date());
  // 		dtServerDate = new Date(serverDt);
  // 	},
  // 	error : function(xhr, status, error){
  // 		dtServerDate = new Date();
  // 	}
  // });

  return dtServerDate;
};

export const utilGetDate = strToken => {
  /*
	 * if ((location.host).indexOf("localhost") == -1){
	 * xhr.open("POST",location.host, false); } else { xhr.open("POST",
	 * location.protocol + "//" + location.host, false); }

	var xhr = new XMLHttpRequest();
	xhr.open("POST", location.protocol + "//" + location.host, false);
	xhr.send(null);

	var dtServerDate = new Date(xhr.getResponseHeader("Date"));
	2013-05-23 강종철
	아래 로직으로 수정합니다
	 */

  var dtServerDate = getServerTime();

  var strYear = '' + dtServerDate.getFullYear();
  var strMonth = '' + (dtServerDate.getMonth() + 1);
  var strDay = '' + dtServerDate.getDate();

  if (strMonth.length == 1) {
    strMonth = '0' + strMonth;
  }
  if (strDay.length == 1) {
    strDay = '0' + strDay;
  }

  return strYear + strMonth + strDay;
};

/**
 * 상령일(보험연령이 한살 더해지는 일자) 계산
 * 상령일 = (현재년(6월이후생일은 -1년)+생월+생일)+6개월(현재일자보다 작으면 +6을 더한다)
 * @param {string} sIdNo 주민번호
 * @param {string} pDate 설계일기준
 * @return {string} 상령일
 * @memberOf form.global
 */
export const getAgeAddDt = (sIdNo, pDate) => {
  var sDt = '';
  //var sToDay = util.getDate();
  var sToDay = utilGetDate();
  var syyyy = Number(sToDay.substring(0, 4));
  var sDate = '';

  if (sIdNo.substring(2, 4) > '06') {
    sDt = String(syyyy - 1) + sIdNo.substring(2, 6);
  } else {
    sDt = String(syyyy) + sIdNo.substring(2, 6);
  }

  if (isDate(sDt)) {
    sDate = addDate(sDt, 'm', 6);
  }
  if (pDate) sToDay = pDate; //설계일기준으로 상령일 산정

  if (sDate <= sToDay) {
    if (isDate(sDate)) {
      sDate = addDate(sDate, 'm', 12);
    }
  }
  return sDate;
};

// 공통 코드 선택 옵션 이름 추출  arr : 선택 옵션 배열 값, cd : 선택 코드 값, defaultNm : 값이 없을 경우 기본값
export const getCmmCdNm = (arr, cd, defaultNm) => {
  let result = defaultNm ? defaultNm : '';
  if (!cd && !arr) {
    return result;
  }

  for (let i = 0; i < arr.length; i++) {
    if (arr[i].val && arr[i].val == cd) {
      result = arr[i].key;
      break;
    }

    if (arr[i].MINOR_CD && arr[i].MINOR_CD == cd) {
      result = arr[i].CODE_NM1;
      break;
    }
  }

  return result;
};

export const chkReturn = (data, strReKey, returnData, rePlusEnd) => {
  var strType = jQuery.type(data);
  var bCheck = true;
  var bReturnData = true;
  var bRePlusEnd = false;
  var strRePlusEnd = '';

  if (strType == 'null' || strType == 'undefined') {
    bCheck = false;
  }

  if (
    jQuery.type(returnData) == 'null' ||
    jQuery.type(returnData) == 'undefined'
  ) {
    bReturnData = false;
  }

  strType = jQuery.type(strReKey);

  if (
    strType == 'null' ||
    strType == 'undefined' ||
    strReKey == 'b' ||
    strReKey == ''
  ) {
    return bCheck;
  }

  if (rePlusEnd != null && rePlusEnd != undefined) {
    bRePlusEnd = true;
    strRePlusEnd = rePlusEnd;
  }

  if (bCheck == true) {
    if (strReKey == 's') {
      if (bRePlusEnd == true && data == '') {
        return returnData;
      } else if (bRePlusEnd == true) {
        return data + strRePlusEnd;
      } else {
        if (data == '' && bReturnData == true) {
          return returnData;
        } else {
          return data + '';
        }
      }
    } else {
      return data;
    }
  } else {
    if (strReKey == 's') {
      if (bReturnData) {
        return returnData;
      } else {
        return '';
      }
    } else if (strReKey == 'n') {
      if (bReturnData) {
        return returnData;
      } else {
        return 0;
      }
    }
  }

  return bCheck;
};

export const isDigit = strNum => {
  // null, undefined, 빈스트링 체크
  if (chkReturn(strNum, 's') == '') {
    return false;
  }

  var len = strNum.length;
  var c;

  for (var i = 0; i < len; i++) {
    c = strNum.charAt(i);
    if ((i == 0 && c == '-') || (c >= '0' && c <= '9')) {
    } else {
      return false;
    }
  }

  return true;
};

export const isFloat = strNum => {
  // null, undefined, 빈스트링 체크
  if (chkReturn(strNum, 's') == '') {
    return false;
  }

  var cnt = 0;
  strNum = strNum + '';

  for (var i = 0; i < strNum.length; i++) {
    // Check that current character is number.
    var c = strNum.charAt(i);

    if (!isDigit(c)) {
      return true;
      if (c == '.') {
        if (cnt > 1) {
          return false;
        } else {
          cnt++;
        }
      } else {
        return false;
      }
    }
  }

  return true;
};

export const setCommas = (strNum, strReText) => {
  var bCheck = true;

  // 입력된 문자열이 숫자와 '.'으로만 이루어져 있는가? 빈스트링은 문자로 본다.
  if (isFloat(strNum) == false) {
    bCheck = false;
  }

  if (bCheck) {
    // strNum = String(Number(strNum));//13-
    strNum = strNum + '';
    var strfirstNum = strNum.split('.')[0];
    var strBackNum = '';

    if (strNum.split('.').length != 1) {
      strBackNum = '.' + strNum.split('.')[1];
    }

    var re = /,|\s+/g;
    strfirstNum = strfirstNum.replace(re, '');

    re = /(-?\d+)(\d{3})/;
    while (re.test(strfirstNum)) {
      strfirstNum = strfirstNum.replace(re, '$1,$2');
    }

    return strfirstNum + strBackNum;
  } else {
    if (chkReturn(strReText, 's') == '') {
      return '';
    } else {
      return strReText;
    }
  }
};
